import { useBaseApiMutation } from "@mutation/baseMutation";

export const useNotificationClubCreateMutation = () =>{

    return useBaseApiMutation(
        {
            method: "POST",
            endpoint: `/club/{club_uuid}/notification`
        }
    )
}

export const useNotificationSiteCreateMutation = () =>{

    return useBaseApiMutation(
        {
            method: "POST",
            endpoint: `/site/{site_uuid}/notification`
        }
    )
}

